/**
 * Render control characters as visible escapes, so text shown on an approval
 * card is READ rather than painted by the terminal-ish renderer.
 *
 * Everything below 0x20 except `\n` (which a `pre` renders honestly as a line
 * break, and which the user must be able to see as one), plus DEL. `\r`, `\t`
 * and `\x1b` get their familiar spellings so the text still reads.
 *
 * Shared by the MCP terminal approval modal and the in-app assistant's approval
 * card: a `\r` that scrolls half a command out of view, or an `\x1b[2J` that
 * clears it, would hide exactly the part worth hiding.
 */
export function visibleEscapes(text) {
  if (typeof text !== 'string') return '';
  let out = '';
  for (const ch of text) {
    const code = ch.codePointAt(0);
    if (ch === '\n') out += ch;
    else if (ch === '\r') out += '\\r';
    else if (ch === '\t') out += '\\t';
    else if (ch === '\x1b') out += '\\x1b';
    else if (code < 0x20 || code === 0x7f) {
      out += `\\x${code.toString(16).padStart(2, '0')}`;
    } else out += ch;
  }
  return out;
}
